<main>
    <div class="container">

        <div class="row">
            <div class="col-sm-6 col-md-9">
                <div _ngcontent-cvh-c14="" class="component-title mb-3">
                    STATUS DE CARTÕES
                </div>
                <p>Veja os status dos cartões de seus favorecidos</p>
            </div>
        </div>

        <div class="separador-2"></div>

        <div class="row">
            <div class="col-md-12 text-right">
                <ul class="options-cadastro">
                    <li>
                        <div class="list-select ml-2 my-1">
                            Mostrar:
                            <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                <option _ selected="" value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="row mt-5">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-bordered table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th>QR Code</th>
                                <th>Colaborador</th>
                                <th>CPF</th>
                                <!-- <th>Situação</th> -->
                            </tr>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor="let card of cards | paginate : {
                                            itemsPerPage: showItem,
                                            currentPage: currentPage,
                                            totalItems: totalItems}">
                                <td>{{ card.cardQrCode }}</td>
                                <td>{{ card.collaboratorName }}</td>
                                <td>{{ card.collaboratorDocument }}</td>
                                <!-- <td>
                                    <span *ngIf="card.cardStatus">
                                        <img class="img-status" src="./assets/icons/status-green.png" />
                                    </span>
                                    <span *ngIf="!card.cardStatus">
                                        <img class="img-status" src="./assets/icons/status-yellow.png" />
                                    </span>
                                </td> -->
                            </tr>
                        </tbody>
                    </table>

                    <div class="list-pagination ml-auto">
                        <pagination-controls (pageChange)="pageChangedGateway($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
</main>